import { InjectedConnector } from "@web3-react/injected-connector";
import {ChainId} from "../constants/networks";

export const connector = new InjectedConnector({
  supportedChainIds: [ChainId.ARBITRIUM_SEPOLIA ]
})
